"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentencesArrayToColumnsOrSentences = exports.columnsOrSentencesToSentencesArray = void 0;
const inline_1 = require("../../../node/cst/inline");
const std = __importStar(require("../../../law/std"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const util_1 = require("../../../util");
const columnsOrSentencesToSentencesArray = (els) => {
    const sentencesArray = [];
    for (let i = 0; i < els.length; i++) {
        const sentences = new inline_1.Sentences("", null, [], []);
        const el = els[i];
        if (el.tag === "Sentence") {
            if (el.attr.WritingMode && (el.attr.WritingMode !== std.defaultAttrs.Sentence.WritingMode)) {
                sentences.attrEntries.unshift(new inline_1.AttrEntry(`[WritingMode="${el.attr.WritingMode}"]`, ["WritingMode", el.attr.WritingMode], null, "", null));
            }
            sentences.sentences.push(el);
        }
        else if (el.tag === "Column") {
            sentences.leadingSpace = i === 0 ? "" : toCSTSettings_1.default.MARGIN;
            if (el.attr.LineBreak && (el.attr.LineBreak !== std.defaultAttrs.Column.LineBreak)) {
                sentences.attrEntries.unshift(new inline_1.AttrEntry(`[LineBreak="${el.attr.LineBreak}"]`, ["LineBreak", el.attr.LineBreak], null, "", null));
            }
            sentences.sentences.push(...el.children);
        }
        else if (el.tag === "Table") {
            throw new util_1.NotImplementedError(el.tag);
        }
        else {
            (0, util_1.assertNever)(el);
        }
        sentencesArray.push(sentences);
    }
    return sentencesArray;
};
exports.columnsOrSentencesToSentencesArray = columnsOrSentencesToSentencesArray;
const sentencesArrayToColumnsOrSentences = (sentencesArray) => {
    return sentencesArray.length === 1
        ? sentencesArray[0].sentences
        : sentencesArray.map(c => {
            const leadingSpaceRange = c.leadingSpaceRange;
            const lastSentenceRange = c.sentences.slice(-1)[0].range;
            return std.newStdEL("Column", Object.fromEntries(c.attrEntries.map(e => e.entry)), c.sentences, (leadingSpaceRange && lastSentenceRange ? [leadingSpaceRange[0], lastSentenceRange[1]] : null));
        });
};
exports.sentencesArrayToColumnsOrSentences = sentencesArrayToColumnsOrSentences;
//# sourceMappingURL=columnsOrSentences.js.map